export class Userclass {
  FirstName: string;
  LastName: string;
  UserName: string;
  Email: string;
  BCCEmail: string;
  Status: string;
  RoleID: string;
  Type: string;
  TenantId: string;
  Hotelid: string;
  Useruniqueno: string;
  SearchdropFirst: string;
  SearchdropSecond: string;
  SearchMatchesFirst: string;
  SearchMatchesSecond: string;
  SearchtextFirst: any;
  SearchtextSecond: any;
  SearchdropFirstList: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'FirstName', Text: 'First Name' },
    { Value: 'LastName', Text: 'Last Name' },
    { Value: 'UserName', Text: 'Username' },
    { Value: 'Email', Text: 'Email' },
    { Value: 'Role', Text: 'Role' }
  ]
  SearchdropSecondList: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'FirstName', Text: 'First Name' },
    { Value: 'LastName', Text: 'Last Name' },
    { Value: 'UserName', Text: 'Username' },
    { Value: 'Email', Text: 'Email' },
    { Value: 'Role', Text: 'Role' }
    ]
}



// WEBPACK FOOTER //
// ./src/app/Classes/Userclass.ts